module.exports = __webpack_public_path__ + "img/vegetable-corn-350x184.65da7efb.jpg";